module.exports = require("hammerjs");